import React, { useEffect } from "react";

//Import Breadcrumb
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid } from "@mui/material";

const CheckBoxGroup = ({ title, data, setCheckBoxValue, row, onChange, setValue, disabled }) => {

    useEffect(() => {

        data && data.map((y, idx) =>
            setValue(prevState => ({
                ...prevState, // Copy the previous state
                permissions: {
                    ...prevState.permissions, // Copy the previous permissions
                    [y.name]: y.state // Update the "create-admin" permission
                }
            })))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handleChange = (event) => {
        setCheckBoxValue(prevPawn =>
            prevPawn.map(item =>
                item.name === event.target.value ? { ...item, state: event.target.checked } : item
            )
        )
    }

    return (
        <React.Fragment>
            <FormControl variant="standard" fullWidth>
                <Grid container>
                    <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>{title}</FormLabel>
                    <Grid item xs={12}>
                        <FormGroup row={row} sx={{ display: "flex" }}>
                            {
                                data && data.length > 0 && data.map((x, idx) =>
                                    <FormControlLabel key={idx}
                                        sx={{marginBottom: "0px"}}
                                        control={
                                            <Checkbox checked={x.state} disabled={disabled}
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: "var(--bs-theme-color)",
                                                    },
                                                    color: '#52525280'
                                                }}
                                                onChange={(event) => disabled ? "" : (handleChange(event),onChange && onChange(event))} value={x.name} />
                                        }
                                        label={<span style={{ fontFamily: 'Manrope', fontSize: 14 }}>{x.label}</span>}
                                    />
                                )
                            }
                        </FormGroup>
                    </Grid>

                </Grid>
            </FormControl>

        </React.Fragment >
    );
};

export default CheckBoxGroup;
